import React, { PropsWithChildren } from 'react';

import { Card } from '../Card';

import { useBackgroundByContext } from '@/hooks/useBackgroundByContext';
import { PropsWithClassName } from '@/types';
import { EnumContextGDT } from '@/types/team';
import { cn } from '@/utils/functions';

interface Props extends PropsWithChildren, PropsWithClassName {
  context?: EnumContextGDT;
}

export const MainBox = React.memo(
  ({
    children,
    className,
    context = EnumContextGDT.FriendTournament,
  }: Props) => {
    const bgMain = useBackgroundByContext({ context });

    return (
      <Card
        className={cn(
          'p-0 bg-white overflow-hidden w-full flex mt-10 min-h-[28rem]',
          className
        )}
      >
        <figure
          className="min-w-72 max-w-72 bg-cover"
          style={{ backgroundImage: `url(${bgMain?.default})` }}
          title={context}
        />
        <div className="flex flex-1 flex-col text-center justify-center">
          {children}
        </div>
      </Card>
    );
  }
);

MainBox.displayName = 'MainBox';
